import gql from 'graphql-tag';

import ExtractByTypename from 'graphql-client/ExtractByTypename';

import {UnitTypesQuery} from './__generated/UnitTypesQuery';

export const UNITS_QUERY = gql`
  query UnitsQuery($ids: [StrictString!]!, $versionNumbers: [StrictInt!])
  @skipAudit
  @engComponent(name: UNITS) {
    units(ids: $ids, versionNumbers: $versionNumbers) {
      ... on UnitNode {
        id
        name
        symbol
        aliases
        conversionFactor
        versionNumber
        unitType {
          ... on UnitTypeNode {
            id
            name
            terms {
              value
              exponent
            }
            overrideIsConcentration
            overrideIsContainerQuantity
            baseUnit {
              ... on UnitNode {
                id
                name
                symbol
                conversionFactor
                versionNumber
              }
            }
          }
        }
      }
    }
  }
`;

export const UNITS_ELLIPSIZE_LENGTH = 7;

export const UNIT_TYPES_QUERY = gql`
  query UnitTypesQuery @skipAudit @engComponent(name: UNITS) {
    unitTypes {
      ... on UnitTypeNode {
        id
        name
        terms {
          value
          exponent
        }
        formula {
          value {
            id
          }
          exponent
        }
        overrideIsConcentration
        overrideIsContainerQuantity
        archiveData {
          archived
          purpose
        }
        baseUnit {
          id
          name
          symbol
          aliases
          conversionFactor
          versionNumber
          siName
          archiveData {
            archived
            purpose
          }
        }
        units {
          id
          name
          symbol
          aliases
          conversionFactor
          versionNumber
          siName
          archiveData {
            archived
            purpose
          }
          unitType {
            id
          }
        }
      }
    }
  }
`;

export type UnitTypesQueryUnitTypeNode = ExtractByTypename<
  UnitTypesQuery['unitTypes'][number],
  'UnitTypeNode'
>;
